import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
import MainPagetitle from '../../layouts/MainPagetitle';
import { Modal, Button } from 'react-bootstrap';
import FeatureService from '../../api/services/FeatureService';

const EditFeature = () => {
  var imageUrl = process.env.REACT_APP_LARAVEL_FEATURE_IMAGE_URL;
  const params = useParams();
  const [error, setError] = useState("")
  const [featureModal, setFeatureModal] = useState(false);
  const [feature, setFeature] = useState([]);
  const [file, setFile] = useState()
  const [smallicon, setSmallIcon] = useState()
  const [isLoading, setisloading] = useState(true);
  useEffect(() => {
    var id = params.id;
    getFeatureByID(id);
  }, []);

  const handleChange = (e) => {
    setFeature({
      ...feature, [e.target.name]: e.target.value,
    });
  };

  const getFeatureByID = async (id) => {
    try {
      let feature = await FeatureService.show(id).json();
      setFeature(feature.data);
      setisloading(false);
    } catch (error) {
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
      }
    }
  };
  const onFileChange = (e) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(e.target.files[0])
    fileReader.onload = () => {
      var icon = fileReader.result
      setFile(icon)
    }
  }
  const onIconChange = (e) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(e.target.files[0])
    fileReader.onload = () => {
      var smallicon = fileReader.result
      setSmallIcon(smallicon)
    }
  }
  const onSubmit = async (event) => {
    event.preventDefault();
    setError("")
    try {
      var userData = {
        "title": event.target.title.value,
        "de_title": event.target.de_title.value,
        "icon": file ? file.split(',')[1] : "",
        "smallicon": smallicon ? smallicon.split(',')[1] : ""
      }
      let responseData = await FeatureService.update(params.id, userData).json()
      if (responseData.status === true) {
        setFeatureModal(true)
      }
    } catch (error) {
      console.log(error)
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
      }
    }
  };
  return (
    <>
      <MainPagetitle mainTitle="Feature" pageTitle={'Feature'} parentTitle={'Home'} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Edit Feature</h4>
              </div>
              <div className="card-body">
                <form className="form-valide" onSubmit={onSubmit}>
                  <div className="row">
                    {error && <h5 style={{ color: 'red' }}>{error}</h5>}
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >English Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='title' id="val-username"
                        defaultValue={
                          feature.title
                            ? feature.title
                            : ''
                        } />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >German Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='de_title' id="val-username" placeholder=""  defaultValue={
                          feature.de_title
                            ? feature.de_title
                            : ''
                        }/>
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-number" className="form-label">Icon <span className="text-danger">*</span></label>
                      {feature.icon ? <img className="img-drop-area" height={100} width={100} name="icon" src={file ? file : imageUrl + feature.icon} alt='' /> : null}
                      <input type="file" className="form-control" name='icon' onChange={onFileChange} accept="image/png, image/jpeg, image/svg+xml" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-number" className="form-label">Icon <span className="text-danger">*</span></label>
                      {feature.icon ? <img className="img-drop-area" height={100} width={100} name="smallicon" src={smallicon ? smallicon : imageUrl + feature.smallicon} alt='' /> : null}
                      <input type="file" className="form-control" name='smallicon' onChange={onIconChange} accept="image/png, image/jpeg, image/svg+xml" />
                    </div>
                  </div>
                  <div>
                    <button type="submit" className="btn btn-primary mb-2 me-1"  >Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoading && <LogoAnimationLoader />}
      <Modal centered className="mark-attendence" show={featureModal}>
        <Modal.Header>
          <Modal.Title>Update </Modal.Title>
          <Button variant="" className="btn-close" onClick={() => setFeatureModal(false)}></Button>
        </Modal.Header>
        <Modal.Body>Update Service Successfully!!!.</Modal.Body>
        <Modal.Footer>
          <Link className="btn btn-primary" to='/admin/feature' variant="danger light" onClick={() => setFeatureModal(false)}>Close</Link>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default EditFeature;